import { Alert, Box, FormControlLabel, FormHelperText, Grid, IconButton, Radio, RadioGroup } from '@mui/material';
import React, { Component } from 'react';
import Creatable from '../../common/Creatable';
import DateTimePicker from '../../common/DateTimePicker';
import Dialog from '../../common/Dialog';
import InputText, { InputSelect } from '../../common/Form';
import _, { isEmpty } from 'lodash'
import { SCHCOLORS } from '../../../utils/generalFuncs';
import ColorPicker from '../../common/ColorPicker';
import { SearchRounded } from '@mui/icons-material';
import axios from 'axios';
// import { tmpPaygoList } from '../../Admin/Chantiers/ChantierFormPopUp';

class TimeSheetForm extends Component {
    state = { 
        startDate: this.props.timesheet ? this.props.timesheet.startDate :  new Date(),
        endDate: this.props.timesheet ? this.props.timesheet.endDate :  new Date(),
        project_id: this.props.timesheet && this.props.timesheet.project_id ? {value: this.props.timesheet.project_id, label:this.props.PROJECTS[this.props.timesheet.project_id].project_name }:  {value: "", label: ""},
        timesheet_desc: this.props.timesheet ? this.props.timesheet.timesheet_desc :  "",
        title: this.props.timesheet ? this.props.timesheet.title :  "",
        timesheet_chantier: this.props.timesheet ? this.props.timesheet.timesheet_chantier :  "",
        event_type: this.props.timesheet ? this.props.timesheet.event_type :  "PROJECT",
        // color: this.props.timesheet ? this.props.timesheet.color :  "",
        color: "",
        clientName: "",
        boxAssoId: "",
        paygoID: "",
        errors: {
            project_id: "",
            title: "",
            event_type: "",
            startDate: "",
            endDate: "",
            timesheet_chantier: "",
        }
    }
    componentDidMount = () => {
        if (this.props.timesheet){
            
            if (this.props.timesheet.timesheet_chantier){
                this.fetchChantierInfo(this.props.timesheet.timesheet_chantier)
            }
        }
    }

    fetchChantierInfo = async (itemID) => {
        // paygo or boxAsso (if update)
        let res = await axios.post("/chantiers/resume/info", [itemID])
        // let res = await this.props.getClientInfo(paygoList)
        let clientName = ""
        let boxAssoId = ""
        let paygoID = ""
        let errors = {}
        if(!isEmpty(res.data.content.info) ){

            let clientObject = {}
            res.data.content.info.map(client => {
                client.map((field, index) => {
                    clientObject[res.data.content.name[index]] = field
                })
            })   

            if(isEmpty(clientObject.boxAssoId)){
                errors.timesheet_chantier = "Paygo ID Introuvable"
            } else{
                errors.timesheet_chantier = ""
                clientName =  clientObject.clientName
                boxAssoId =  clientObject.boxAssoId
                paygoID =  clientObject.idBox

            }
        } else {
            errors.timesheet_chantier = "Paygo ID Introuvable"
        }
            
        this.setState({ 
            errors,
            clientName, 
            boxAssoId,
            paygoID
        })

    }

    hanleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }
    handleChangeProject = (option) => {
        if(option && (typeof option != "string")){
            this.setState({
                project_id: option
            })
        } else {
            this.setState({
                project_id: {value: "", label: ""}
            })

        }
    }
    setColor = (color) => {
        this.setState({
            color
        })
    }
    searchPaygo = async () => {
        const { paygoID } = this.state;
        let noError = true
        let errors = {}
        let clientName = ""
        let boxAssoId = ""

        if(!isEmpty(paygoID)){

            let res = await axios.post("/chantiers/resume/info", [paygoID])
            // let res = await this.props.getClientInfo(paygoList)
    
            if(!isEmpty(res.data.content.info) ){
    
                let clientObject = {}
                res.data.content.info.map(client => {
                    client.map((field, index) => {
                        clientObject[res.data.content.name[index]] = field
                    })
                })   
    
                if(isEmpty(clientObject.boxAssoId)){
                    errors.timesheet_chantier = "Paygo ID Introuvable"
                    noError = false
                } else{
                    errors.timesheet_chantier = ""
                    clientName =  clientObject.clientName
                    boxAssoId =  clientObject.boxAssoId
    
                }
            } else {
                errors.timesheet_chantier = "Paygo ID Introuvable"
                noError = false
            }
                
        }

        this.setState({ 
            errors,
            clientName, 
            boxAssoId 
        })
        return noError

    }

    validate = () => {
        const { startDate, endDate, project_id, event_type, title, timesheet_desc} = this.state;
        let noError = true
        let errors = {}

        if (isEmpty(event_type)){
            noError =  false
            errors.event_type = "Veuillez remplir ce Champ" 
        }
        if ((event_type === "PROJECT") && (isEmpty(project_id.value)) ){
            noError =  false
            errors.project_id = "Veuillez remplir ce Champ" 
        }
        if ((event_type === "OTHER" || event_type === "CHANTIER") && isEmpty(title) ){
            noError =  false
            errors.title = "Veuillez remplir ce Champ" 
        }
        if (!startDate){
            noError =  false
            errors.startDate = "Veuillez remplir ce Champ" 
        }
        if (!endDate){
            noError =  false
            errors.startDate = "Veuillez remplir ce Champ" 
        }
        if (isEmpty(timesheet_desc)){
            noError =  false
            errors.timesheet_desc = "Veuillez remplir ce Champ" 
        }
        if (startDate && endDate && startDate > endDate) {
            noError =  false
            errors.startDate = "La date de début ne peut pas être postérieure à l'heure de fin" 
        }
    
        this.setState({
            errors
        })
        return noError
    }
    handleSubmit = async () => {
        if(this.validate()){
            let found = await this.searchPaygo()
            
            if(this.state.paygoID && !found){
                // this.props.notif("error", "Le formulaire contient des erreurs" )
            } else {
                let data = {}
                if (this.props.update) {
                    data = Object.assign({}, this.props.timesheet)
                }
                data.startDate = this.state.startDate
                data.endDate = this.state.endDate
                data.timesheet_desc = this.state.timesheet_desc
                data.timesheet_chantier = this.state.boxAssoId
                data.event_type = this.state.event_type
                data.color = this.state.color
    
                if (this.state.event_type === "PROJECT") {
                    data.project_id = this.state.project_id.value
                    data.title = ""
                } else {
                    data.project_id = ""
                    data.title = this.state.title
                    if (data.event_type === "ABS" ){
                        data.title = "Congés "
                    } 
                }
    
                if(this.props.update){
                    await this.props.updateTimesheet(data)
                } else {
                    await this.props.newTimesheet(data)  
                }
    
                if(this.props.STATE.timesheets.error){
                    console.log('====================================');
                    console.log("ERROR", this.props.STATE.timesheets );
                    console.log('====================================');
                    !this.props.update && this.props.notif("error",`Un problème est survenu: ${this.props.STATE.timesheets.error}`)
                } else {
                    !this.props.update && this.props.notif("success","La tâche a été créée avec succès")
                    // this.props.update && this.props.notif("success","La tâche a été modifiée avec succès")
                    this.props.handleClose()
                }
            }

        } else {
            !this.props.update && this.props.notif("error", "Le formulaire contient des erreurs" )
        }

    }
    render() {
        const { PROJECTS, update } = this.props;
        const { event_type } = this.state;

        console.log("STATE",this.state);
        return (
            <Dialog
                close={this.props.handleClose}
                title="Nouvelle tâche"
                submitAction={this.handleSubmit} 
                disabledSubmit={this.props.STATE.timesheets.fetching}
                submitTitle={"Créer"}
                maxWidth="sm"
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <RadioGroup
                            aria-label="Type"
                            style={{ flexDirection: 'row' }}
                            name="event_type"
                            value={event_type}
                            onChange={(e) => this.setState({ event_type: e.target.value})}
                        >
                            <FormControlLabel value="PROJECT" control={<Radio />} label="Projet" />
                            <FormControlLabel value="CHANTIER" control={<Radio />} label="Chantier" />
                            <FormControlLabel value="ABS" control={<Radio />} label="Congés" />
                            <FormControlLabel value="OTHER" control={<Radio />} label="Autre" />
                        </RadioGroup>
                        <FormHelperText>{this.state.errors.event_type}</FormHelperText>
                    </Grid>
                    <Grid item xs={12} >
                        {event_type === "PROJECT" &&
                        <InputSelect
                            label="Projet"
                            required
                            error={this.state.errors.project_id}
                            id="project_id"
                            labelWidth={100} 
                            placeholder="Selectionnez un projet"
                            options={Object.values(PROJECTS).map( item => ({
                                label: item.project_name,
                                value: item.project_id
                            }))}
                            value={this.state.project_id}
                            onChange={this.handleChangeProject}
                        />
                        }
                        {(event_type === "OTHER" || event_type === "CHANTIER") &&
                            <InputText
                                required
                                label={(event_type === "CHANTIER" ? "Nom du chantier" : "Titre")}
                                name="title"
                                value={this.state.title}
                                error={this.state.errors.title}
                                onChange={this.hanleChange}
                            />
                        }
                        {event_type === "CHANTIER" &&
                        <Box>
                            <InputText
                                required
                                label={"Paygo ID"}
                                name="paygoID"
                                value={this.state.paygoID}
                                error={this.state.errors.timesheet_chantier}
                                onChange={this.hanleChange}
                                endAction={
                                    <IconButton onClick={this.searchPaygo} color="primary">
                                        <SearchRounded />
                                    </IconButton>
                                }
                            />
                            {this.state.clientName &&
                                <Alert severity="info">
                                    {this.state.clientName}
                                </Alert>
                            }

                        </Box>
                        }
                    </Grid>
                    
                    <Grid item xs={12} sm={6}>
                        <DateTimePicker
                            required
                            label="Debut"
                            handleChange={update ? (date) => this.setState({ startDate: date}) : (date) => this.setState({ startDate: date, endDate: date}) }
                            value={this.state.startDate}
                            id="startDate"
                            // maxDate={this.state.endDate || new Date()}
                            error={this.state.errors.startDate}

                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <DateTimePicker
                            required
                            label="Fin"
                            handleChange={(date)=> this.setState({ endDate: date})}
                            value={this.state.endDate}
                            id="endDate"
                            // maxDate={new Date()}
                            // minDate={this.state.startDate || new Date()}
                            error={this.state.errors.endDate}
                        />
                    </Grid>
                    {/* <Grid item xs={12}>
                        <DateRangePicker
                            required
                            label="Fin"
                            handleChange={(date)=> this.setState({ endDate: date})}
                            value={this.state.endDate}
                            id="endDate"
                            maxDate={new Date()}
                            minDate={this.state.startDate || new Date()}
                        />
                    </Grid> */}

                    <Grid item xs={12}>
                        <InputText
                            multiline
                            rows={4}
                            required
                            label="Commentaire"
                            name="timesheet_desc"
                            value={this.state.timesheet_desc}
                            error={this.state.errors.timesheet_desc}
                            onChange={this.hanleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Box p={1} style={{overflow: "auto"}}>
                            <ColorPicker small setColor={this.setColor} selected={this.state.color} notAvailable={[]} />
                        </Box>
                    </Grid>
                </Grid>

            </Dialog>
        );
    }
}

export default TimeSheetForm;